import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=c2537bda&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports